import { render, staticRenderFns } from "./ModalB2COrder.vue?vue&type=template&id=d0ebd552"
import script from "./ModalB2COrder.vue?vue&type=script&lang=js"
export * from "./ModalB2COrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports